import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetAttachmentByMeterIdsGQL } from '../../../../../generated/gatewaygql';
import { DomSanitizer } from '@angular/platform-browser';
import { Utils } from '../../../utils';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HeaderTemplateData } from '../dialog-data.interface';

export interface DialogData {
    header: HeaderTemplateData
    meterIds: number[];
}

@Component({
  selector: 'meter-attachment-dialog',
  templateUrl: 'meter-attachment-dialog.html',
  styleUrls: ['meter-attachment-dialog.scss'],
})

export class MeterAttachmentDialog implements OnInit {
  result: any = [] ;
  index:number = 0;
  utils = Utils;
  public items: any[] = [
    { title: 'E-Commerce item 1', url: 'https://bit.ly/2VlsHZ8' },
    { title: 'E-Commerce item 2', url: 'https://bit.ly/2TmQeeW' },
    // { title: 'E-Commerce item 3', url: 'https://bit.ly/2NrURzf' },
    // { title: 'E-Commerce item 4', url: 'https://bit.ly/2EcKcnD' },
    // { title: 'E-Commerce item 5', url: 'https://bit.ly/2U9KYse' },
    // { title: 'E-Commerce item 6', url: 'https://bit.ly/2EcLlLX' },
    // { title: 'E-Commerce item 7', url: 'https://bit.ly/2Vr5jd9' }
];
//  width = '100%';
//  height = '100px';
 imgSrc: string ;

 customOptions: OwlOptions = {
  loop: false,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  autoWidth:false,
  dots: true,
  navSpeed: 700,
  navText: ['', ''],
  margin:10,
}
  header:HeaderTemplateData;

  constructor(
    public domSanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<MeterAttachmentDialog>,
    @Inject(MAT_DIALOG_DATA) private _data: DialogData,
    private getAttachmentByMeterIdsGQL : GetAttachmentByMeterIdsGQL
  ) {
    if (this._data.meterIds.length > 0) {
      this.getAttachmentByMeterIdsGQL.fetch({
        MeterId:this._data.meterIds
      }).subscribe(x => {
        this.result = x.data.getMeterAttachmentByIds;
        this.result?.forEach(x=>{
          x['Attachment'].imageUrl = domSanitizer.bypassSecurityTrustUrl(this.utils.convertBase64ToFile(x['Attachment']))
        });
        this.imgSrc= this.result[0]?.Attachment?.imageUrl
      });
    }

    if(_data.header){
      this.header = _data.header;
    }
  }

  download(url){
    window.open(url);
  }

  changeImg(url: string,index:number) {
    this.imgSrc = url;
    this.index = index;
  }

  ngOnInit() {
  }


}
